module.exports = __webpack_public_path__ + "static/media/cancel_red.03c182b1.svg";